import { render, staticRenderFns } from "./wTable.vue?vue&type=template&id=5fe6bfa0&"
import script from "./wTable.vue?vue&type=script&lang=js&"
export * from "./wTable.vue?vue&type=script&lang=js&"
import style0 from "./wTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports